import React from 'react';

import SignupLegalScreen from './SignupLegalScreen';

export default (props: any) => <SignupLegalScreen {...props} type="privacy" progressStatus={100 / 10 * 9} />;
